import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [displayUrl, setDisplayUrl] = useState(imageUrl || "");

	useEffect(() => {
		if (!imageUrl) return;
		let objectUrl = "";
		let canceled = false;

		setDisplayUrl(imageUrl);

		const fetchImage = async () => {
			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				objectUrl = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				if (!canceled) {
					setDisplayUrl(objectUrl);
				}
			} catch (error) {
				if (!canceled) {
					setDisplayUrl(imageUrl);
				}
			}
		};

		fetchImage();

		return () => {
			canceled = true;
			if (objectUrl) {
				window.URL.revokeObjectURL(objectUrl);
			}
		};
	}, [imageUrl]);

	return (
		<ModalImage
			className={classes.messageMedia}
			small={displayUrl || imageUrl}
			smallSrcSet={displayUrl || imageUrl}
			medium={displayUrl || imageUrl}
			large={displayUrl || imageUrl}
			alt="image"
		/>
	);
};

export default ModalImageCors;
